<template>
  <router-view />
</template>

<style>
html,
body {
  margin: 0;
  padding: 0;
}

#app {
  font-family: "Roboto", sans-serif;
}
</style>
